// extracted by mini-css-extract-plugin
module.exports = {"status":"status_status__3EaJB","size--small":"status_size--small__3MKFS","size--xs":"status_size--xs__HPdL3","active":"status_active__YusNd"};